import { apiClient } from '../config/ApiClient';
import type { LoginDTO } from '../dto/LoginDTO';
import type {
  ForgetPasswordDTO,
  RegisterDTO,
  ResetPasswordDTO,
} from '../dto/RegisterDTO';
import type { AuthResponseDTO } from '../dto/AuthResponseDTO';

export const login = (data: LoginDTO) =>
  apiClient.post<AuthResponseDTO>('/auth/login', data);

export const registerUser = (data: RegisterDTO) =>
  apiClient.post<string>('/auth/registerUser', data);

export const registerStore = (data: RegisterDTO, thumbnail: File) => {
  const form = new FormData();
  form.append(
    'registerDto',
    new Blob([JSON.stringify(data)], { type: 'application/json' })
  );
  form.append('thumbnail', thumbnail);
  return apiClient.post<string>('/auth/registerStore', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const forgetPassword = (data: ForgetPasswordDTO) =>
  apiClient.post<string>('/auth/forgetPassword', data);

export const resetPassword = (data: ResetPasswordDTO) =>
  apiClient.post<string>('/auth/resetPassword', data);
